import React from "react";
import {
  Target,
  ChevronUp,
  ChevronDown,
  AlertCircle,
  Shield,
} from "lucide-react";

const StockTable = ({
  expandedSection,
  toggleSection,
  sortedStocks,
  handleStockSelect,
  formatCurrency,
  calculateSafetyRating,
}) => {
  return (
    <div className="insights-section">
      <div
        className="section-header clickable"
        onClick={() => toggleSection("valueStocks")}
      >
        <h3>
          <Target size={20} />
          Value Stock Opportunities
        </h3>
        <div className="section-toggle">
          {expandedSection === "valueStocks" ? (
            <ChevronUp size={20} />
          ) : (
            <ChevronDown size={20} />
          )}
        </div>
      </div>

      {expandedSection === "valueStocks" && (
        <div className="section-content">
          {sortedStocks.length > 0 ? (
            <div className="stock-table-container">
              <table className="stock-table">
                <thead>
                  <tr>
                    <th>Stock</th>
                    <th>Current Price</th>
                    <th>Intrinsic Value</th>
                    <th>Discount</th>
                    <th>ROIC</th>
                    <th>Margin</th>
                    <th>Safety Rating</th>
                    <th>Moat</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedStocks.map((stock) => {
                    const discountPercent =
                      ((stock.intrinsicValue - stock.currentPrice) /
                        stock.intrinsicValue) *
                      100;
                    const safetyRating = calculateSafetyRating(stock);

                    return (
                      <tr
                        key={stock.symbol}
                        onClick={() => handleStockSelect(stock)}
                        className="stock-row"
                      >
                        <td className="stock-info">
                          <div className="stock-symbol">{stock.symbol}</div>
                          <div className="stock-name">{stock.name}</div>
                        </td>
                        <td>{formatCurrency(stock.currentPrice)}</td>
                        <td>{formatCurrency(stock.intrinsicValue)}</td>
                        <td className="discount">
                          <span
                            className={
                              discountPercent > 30
                                ? "high"
                                : discountPercent > 20
                                ? "medium"
                                : "low"
                            }
                          >
                            {discountPercent.toFixed(1)}%
                          </span>
                        </td>
                        <td>{stock.roic.toFixed(1)}%</td>
                        <td>{stock.operatingMargin.toFixed(1)}%</td>
                        <td>
                          <div className="safety-rating">
                            <div
                              className="safety-bar"
                              style={{ width: `${safetyRating}%` }}
                            ></div>
                            <span className="safety-value">{safetyRating}</span>
                          </div>
                        </td>
                        <td>
                          <div className="moat-rating">
                            {Array.from({
                              length: Math.round(stock.economicMoat),
                            }).map((_, i) => (
                              <Shield key={i} size={14} className="moat-icon" />
                            ))}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="no-stocks-message">
              <AlertCircle size={48} />
              <p>
                No stocks match your current criteria. Try adjusting your
                filters.
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default StockTable;
